"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const netinfo_1 = __importDefault(require("@react-native-community/netinfo"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const icons_1 = require("../../assets/icons");
const Hamburger_1 = __importDefault(require("../../assets/icons/Hamburger"));
const components_1 = require("../../components");
const LoadingLogin_1 = __importDefault(require("../../components/loading/LoadingLogin"));
const ModalMenu_1 = __importDefault(require("../../components/modal/ModalMenu"));
const CustomText_1 = __importDefault(require("../../components/text/CustomText"));
const scale_1 = require("../../utils/scale");
const styles_1 = __importDefault(require("./styles"));
const DisconnectScreen = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const [menuVisible, setMenuVisible] = (0, react_1.useState)(false);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, title: "", styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(Hamburger_1.default, null), onLeftPress: () => {
                setMenuVisible(true);
            } }),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.body },
            react_1.default.createElement(react_native_1.View, { style: { alignSelf: 'center', marginTop: (0, scale_1.verticalScale)(169) } },
                react_1.default.createElement(icons_1.IC_DISCONNECT, null)),
            react_1.default.createElement(react_native_1.View, { style: { width: '100%', paddingHorizontal: (0, scale_1.scale)(16) } },
                react_1.default.createElement(CustomText_1.default, { weight: '600', style: styles_1.default.title }, "\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u306B\u63A5\u7D9A\u3067\u304D\u307E\u305B\u3093"),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.description }, `通信環境が不安定です。\nネットワークの接続状況を確認してもう一度お試しください。`)),
            react_1.default.createElement(components_1.LinearButton, { title: '\u3082\u3046\u4E00\u5EA6\u8AAD\u307F\u8FBC\u3080', textStyle: styles_1.default.buttonLabel, containerStyle: styles_1.default.button, style: {
                    width: '100%',
                    height: (0, scale_1.scale)(48),
                    borderRadius: (0, scale_1.scale)(4)
                }, onPress: () => {
                    setLoading(true);
                    netinfo_1.default.fetch()
                        .then(response => {
                        if (response.isConnected) {
                            dispatch(slice_1.default.actions.updateConnectionStatus(true));
                        }
                    })
                        .catch(() => { })
                        .finally(() => {
                        const timeout = setTimeout(() => {
                            setLoading(false);
                            clearTimeout(timeout);
                        }, 1000);
                    });
                } })),
        react_1.default.createElement(ModalMenu_1.default, { visible: menuVisible, onClose: () => setMenuVisible(false) }),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = DisconnectScreen;
